import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addpricetype',
  templateUrl: './addpricetype.component.html',
  styleUrls: ['./addpricetype.component.css']
})
export class AddpricetypeComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  saveloading: boolean;
  //Save Validation
  submitted: boolean;
  successfully: boolean;


  //Edit Get Values
  pricetypeColl: any = [];
 

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  pricetypeform = new FormGroup({
    pricetypeid: new FormControl(0),
    pricetypename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Pricetype";

  @Input() pricetypeid: number = 0
  @Input() pricetypename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.pricetypeid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit(){
 
    this.loginService.fnSetFirstControlFocus('Pricetypename');
  }
  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.pricetypeform.reset();
      this.fnInitializePricetype();

      if (this.pricetypeid > 0) {
        this.fngetPricetype();
      }
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.pricetypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializePricetype() {
    this.pricetypeform.setValue({

      pricetypeid: 0,
      pricetypename: '',
      inactive:false,
    })
  }
 
  //Get 
  fngetPricetype() {
   
    var data = {
      'pricetypeid': this.pricetypeid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getPricetype(data)
      .subscribe(
        (res) => {
          this.pricetypeColl = res.json().result;
          var editdata = this.pricetypeColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.pricetypeform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'pricetypeid': this.pricetypeid,
          'pricetypename': this.pricetypeform.get('pricetypename').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.pricetypeform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckPricetype(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.pricetypeform.get('pricetypeid').value > 0) {
                //Update Department
                this.fnSetPricetype(data);
              }
              else {
                //Insert Department
                this.fnInsertPricetype(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.pricetypeform.controls['pricetypename'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertPricetype(data) {
  
    this.appService.fnInsertPricetype(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnpricetypeid = 0;
          if (result.length > 0) {
            rtnpricetypeid = result[0].pricetypeid
           
          }
          this.toastr.success('', "The new Pricetype has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.pricetypeid);

          this.emitData.emit(rtnpricetypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetPricetype(data) {

    this.appService.fnSetPricetype(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().result != "") {
          this.toastr.success('', "The Pricetype has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.pricetypeid, data.pricetypename);

          this.emitData.emit(this.pricetypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.pricetypeform.setValue({

      pricetypeid: deptBO.pricetypeid,
      pricetypename: deptBO.pricetypename,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
